import { paginationSize } from '../../../constants/constants';
import { FETCH_SUBMITTED_TO_TYPIST_VISITS_ERROR, FETCH_SUBMITTED_TO_TYPIST_VISITS_START, FETCH_SUBMITTED_TO_TYPIST_VISITS_SUCCESS, SET_SUBMITTED_TO_TYPIST_VISITS_PAGINATION } from "../../actions/groupadmin/submittedToTypistActions";


const INIT_STATE = {
    submittedToTypist: [],
    loading: false,
    message: '',
    error: '',
    pagination: {
        currentPage: 1,
        pageSize: paginationSize,
        totalPages: 0,
        totalItems: 0,
    },
    searchFilter: {
        searchText: "",
        risId: 1,
        mipIds: [],
        modalityIds: [],
    },
    sortConditions: [{ sortBy: "visitStart", dataType: "DATE", sortType: "desc" }]
}

export const submittedToTypistReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_SUBMITTED_TO_TYPIST_VISITS_START:
            return { ...state, error: '', message: '', loading: true }

        case FETCH_SUBMITTED_TO_TYPIST_VISITS_SUCCESS:
            return { ...state, error: '', message: '', loading: false, submittedToTypist: action.submittedToTypist.length > 0 ? [...action.submittedToTypist] : [] }

        case SET_SUBMITTED_TO_TYPIST_VISITS_PAGINATION: {
            return { ...state, pagination: action.pagination };
        }

        case FETCH_SUBMITTED_TO_TYPIST_VISITS_ERROR:
            return { ...state, loading: false, error: '' }
        default:
            return state;
    }
}

export default submittedToTypistReducer;